import React, { useEffect, useState } from 'react';

interface AnimatedDotsProps {
  className?: string;
  style?: React.CSSProperties;
}

/**
 * AnimatedDots - Shows animated dots (ellipsis) that cycle through:
 * 0ms = no dots
 * 200ms = one dot .
 * 400ms = two dots . .
 * 600ms = three dots . . .
 * 800ms = no dots (repeat)
 */
const AnimatedDots: React.FC<AnimatedDotsProps> = ({ className, style }) => {
  const [dotCount, setDotCount] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDotCount((prev) => (prev + 1) % 4); // 0, 1, 2, 3, then back to 0
    }, 400);

    return () => clearInterval(interval);
  }, []);

  const dots = '.'.repeat(dotCount);

  return (
    <span className={className} style={style}>
      {dots}
    </span>
  );
};

export default AnimatedDots;
